class HeaderTimer extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', this.initTimer.bind(this));
  }

  initTimer() {
    const timer = this;

    let interval = setInterval(function () {
      let minutes = parseInt(timer.querySelector('.timer_minutes').textContent),
        seconds = parseInt(timer.querySelector('.timer_seconds').textContent);

      --seconds;

      if (seconds < 0) {
        minutes--;
      }

      if (minutes < 0 && seconds < 0) {
        minutes = 0;
        seconds = 0;
        clearInterval(interval);
      }

      if (seconds < 0) {
        seconds = 59;
      } else if (seconds < 10) {
        seconds = '0' + seconds;
      }

      if (minutes < 10) {
        minutes = '0' + minutes;
      }

      timer.querySelector('.timer_minutes').textContent = minutes;
      timer.querySelector('.timer_seconds').textContent = seconds;
    }, 1000);
  }
}

customElements.define('header-timer', HeaderTimer);
